import { Injectable } from "@angular/core";
import { Variables } from "../interfaces/environment.interface";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class EnvironmentStore implements Variables {
  private readonly _recaptcha = new BehaviorSubject<Pick<Variables, 'recaptcha'>>({
    recaptcha: {
      siteKey: ''
    }
  });
  private readonly _crypto = new BehaviorSubject<Pick<Variables, 'crypto'>>({
    crypto: {
      SECRET_KEY: '',
      SECRET_SALT: ''
    }
  });
  private readonly _api = new BehaviorSubject<string>('');

  get recaptcha() {
    return this._recaptcha.getValue().recaptcha;
  }

  get crypto() {
    return this._crypto.getValue().crypto;
  }

  get api() {
    return this._api.getValue();
  }

  setVariables(data: Variables): void {
    this._recaptcha.next({ recaptcha: data.recaptcha });
    this._crypto.next({ crypto: data.crypto });
    this._api.next(data.api);
  }

}
